// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__6O3GX","cell":"ColumnAccessor_cell__1En5B","firstCellAccent":"ColumnAccessor_firstCellAccent__38aI_"};